var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 93 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6217 4.39089C20.3428 1.97335 17.1003 0.452881 13.4908 0.452881C9.88119 0.452881 6.6387 1.97335 4.35978 4.39089C1.92791 6.65639 0.398438 9.87978 0.398438 13.4529C0.398438 17.026 1.92791 20.2494 4.35978 22.5149C6.6387 24.9324 9.88119 26.4529 13.4908 26.4529C17.1003 26.4529 20.3428 24.9324 22.6217 22.5149C24.9006 24.9324 28.1431 26.4529 31.7527 26.4529C35.3623 26.4529 38.6047 24.9324 40.8837 22.5149C43.3155 20.2494 44.845 17.026 44.845 13.4529C44.845 9.87978 43.3155 6.65639 40.8837 4.39089C38.6047 1.97335 35.3623 0.452881 31.7527 0.452881C28.1431 0.452881 24.9006 1.97335 22.6217 4.39089ZM22.637 4.39089H40.8837V22.5301H22.637C25.0689 20.2494 26.5831 17.026 26.5831 13.4681C26.5831 9.91019 25.0689 6.6868 22.637 4.4213V4.39089ZM22.6217 4.39089C20.1899 6.6716 18.6757 9.89499 18.6757 13.4529C18.6757 17.0108 20.1899 20.2342 22.6217 22.4997L4.37508 22.5149V4.37569H22.6217V4.39089Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0821 4.46676C55.3983 4.46676 50.7793 8.02465 50.7793 13.4831C50.7793 18.9416 55.3983 22.5603 62.0821 22.5603C68.0777 22.5603 72.452 19.5954 72.9414 15.4597H68.9495C68.5671 17.4211 66.0282 19.3673 62.0668 19.3673C57.6008 19.3673 54.6795 16.9346 54.6795 13.4679C54.6795 10.0013 57.6008 7.62933 62.0668 7.62933C66.0282 7.62933 68.5518 9.59074 68.9495 11.5217H72.9414C72.452 7.44688 68.0777 4.46676 62.0821 4.46676Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7039 4.90799H75.9414V22.0741H92.3986V18.8811H79.7192V4.89278L79.7039 4.90799Z",
    fill: "#1A1A1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClLogoBlack);
export default __webpack_public_path__ + "static/media/cl-logo-black.ba5798f812f92e1221628fb6158fcd79.svg";
export { ForwardRef as ReactComponent };